import { Page } from 'react-mvvm';


class FreeCompetitionStatusPage extends Page {

    onRemoveChildPage = async () => {
        window.location.href = '/';
    };
}

export default FreeCompetitionStatusPage;
